

import Joi from 'joi';
import { HOST } from "common-import/constants";
import { Request } from "common-import/helpers";
import * as Validator from "./Membership.Validator"

class MembershipAPI {


  /*
  POST http://localhost:3000/memberShip/create
  Content-Type: application/json
  Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjQzMjYyMjA1OTF9.Fr46mr5322DQr4VVDM4ibBSDN5EFENCfhkRfG2P-O7Q

  {
      "name" : "VIP1",
      "features":"Su dung casc tinh nang co ban",
      "price":12324243,
      "unitPrice":"VND"
  }

  */


  create = async (data) => {
    const validator = Validator.VALIDATION_MEMBERSHIP_CREATE;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.post(HOST + "/memberShip/create", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


  /*

  POST http://localhost:3000/memberShip/list
  Content-Type: application/json
  Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjQzMjYyMjA1OTF9.Fr46mr5322DQr4VVDM4ibBSDN5EFENCfhkRfG2P-O7Q

  {

  }

  */
  list = async (data) => {
    const validator = Validator.VALIDATION_MEMBERSHIP_LIST;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.post(HOST + "/memberShip/list", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  /*
    POST http://localhost:3000/memberShip/delete
    Content-Type: application/json
    Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjQzMjYyMjA1OTF9.Fr46mr5322DQr4VVDM4ibBSDN5EFENCfhkRfG2P-O7Q

    {
        "id":"176979188002"
    }

  */
  delete = async (data) => {
    const validator = Validator.VALIDATION_MEMBERSHIP_DELETE;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.post(HOST + "/memberShip/delete", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }

}
export default new MembershipAPI();



// WEBPACK FOOTER //
// ./src/services/membership/Membership.API.js